import React, { useState, useEffect } from "react";
import {
    Grid,
    Typography,
    Button,
    TextField,
    MenuItem,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TablePagination,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Checkbox,
    FormControlLabel
} from "@mui/material";
import FormLabel from "@mui/material/FormLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import { NavLink } from "react-router-dom";
import Layout from "../../components/Wrappers/Layout";
import { Card, Alert } from "reactstrap";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@mui/styles";
import val from "../../getThemeDetails";
import {
    resetGetCustomerIdAndNameList,
    getCustomerIdAndNameList,
} from "../../redux/actions/getCustomerIdAndNameListAction";
// import Autocomplete, {
//     createFilterOptions,
// } from "@mui/material/lab/Autocomplete";
import Autocomplete from "@mui/lab/Autocomplete";
import { createFilterOptions } from "@mui/material";

import { getWayList, resetGetWayList } from "../../redux/actions/getWayListAction";
import { allGatewayMappingList, resetAllGatewayMappingList } from "../../redux/actions/getAllGatewayMappingListAction";
import { getWalletOwnerIdAndNameList, resetGetWalletOwnerIdAndNameList } from "../../redux/actions/getWalletOwnerIdAndNameListAction";
import { createGatewayMapping, resetCreateGatewayMapping } from "../../redux/actions/createGatewayMappingAction";

import { adminGetIntegrationTypeList, resetAdminGetIntegrationTypeList } from "../../redux/actions/adminGetIntegrationTypeListAction";
import { adminGetIntegrationList } from "../../redux/actions/adminGetIntegrationListAction";
import { adminDeleteIntegration, resetAdminDeleteIntegration } from "../../redux/actions/adminDeleteIntegrationAction";
import { adminAddIntegration, resetAdminAddIntegration } from "../../redux/actions/adminAddIntegrationAction";
import { getPaymentModeList, resetGetPaymentModeList } from "../../redux/actions/getPaymentModeListAction";
import { getPaymentBrandList, resetGetPaymentBrandList } from "../../redux/actions/getPaymentBrandListAction";
import { resetDeleteGatewayMapping, deleteGatewayMapping } from "../../redux/actions/deleteGatewayMappingAction";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import "../../components/LoadingSpinner/spinner.css";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DeleteIcon from "@mui/icons-material/Delete";
// import Tooltip from "@mui/material/Tooltip";
import { Tooltip } from "antd";
import BackButton from "../../components/BackButton/BackButton";
// import { AiOutlineSearch } from "react-icons/ai";
import Util from "../../validation";
import NotificationPopups from "../../NotificationPopup/NotificationPopups";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
import SOLogout from "../../components/Logout/SOLogout";
import SearchIcon from "@mui/icons-material/Search";



const useStyles = makeStyles({
    table: {
        minWidth: 650
    }
});

const MemberMapping = () => {

    const classes = useStyles();
    const dispatch = useDispatch();
    const filterOptions = createFilterOptions({
        matchFrom: "any",
        limit: 500,
    });


    // useStates
    const [memberId, setMemberId] = useState("");
    const [page, setPage] = useState(0);
    const [deleteMapId, setDeleteMapId] = useState("");
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [pageNo, setPageNo] = useState(0)
    const [integrationname, setIntegrationName] = useState("");
    const [addOpen, setAddOpen] = React.useState(false);
    const [Open, setOpen] = React.useState(false);
    const [openConfirm, setopenConfirm] = React.useState(false);
    const [getWalletOwnerIdStatus, setGetWalletOwnerIdStatus] = useState(false);
    const [tableMappingList, setTableMappingList] = useState([]);
    const [getIntegrationListArray, setGetIntegrationListArray] = useState([]);
    const [getIntegrationListStatus, setGetIntegrationListStatus] =
        useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [searchIntegrationType, setSearchIntegrationType] = useState("");
    const [getIntegrationTypeArray, setGetIntegrationTypeArray] = useState([]);
    const [dialogIntegrationType, setDialogIntegrationType] = useState("");

    const [user, setUser] = useState({
        MemberID: "",
        PayModeID: "",
        CardTypeID: "",
        Gateway: "",
    });

    const {
        MemberID,
        PayModeID,
        CardTypeID,
        Gateway,
    } = user;

    const onInputChange = ({ target: { name, value } }, type) => {

        const obj = {
            ...user
        };

        // validations
        if (type == "number") {
            obj[name] = Util.verifyMobile(value) ? value : obj[name];
        } else if (type == "alphabet") {
            obj[name] = Util.verifyAlphabet(value) ? value : obj[name];
        } else if (type == "both") {
            obj[name] = Util.alphaNumeric(value) ? value : obj[name];
        } else if (type == "url") {
            obj[name] = Util.verifyUrl(value) ? value : obj[name];
        } else {
            // obj[name] = value.trim()
            //obj[name] = Util.noWhiteSpace(value) ? value : obj[name];
            // obj[name] = value.length ? value : obj[name];
            obj[name] = value;
        }
        setUser(obj);
    };

    // useSelectors
    const regenerateTokenRes = useSelector(
        ({ regenerateToken }) => regenerateToken
    );
    var authToken = regenerateTokenRes.data.AuthToken;

    const getCustomerIdAndNameListRes = useSelector(
        ({ getCustomerIdAndNameList }) => getCustomerIdAndNameList
    );
    const getWayListRes = useSelector(({ getWayList }) => getWayList);

    const deleteMapping = useSelector(({ deleteGatewayMapping }) => deleteGatewayMapping);

    const getAllGatewayMappingListRes = useSelector(
        ({ getAllGatewayMappingList }) => getAllGatewayMappingList
    )

    const getPaymentBrandListRes = useSelector(
        ({ getPaymentBrandList }) => getPaymentBrandList)

    const getPaymentModeListRes = useSelector(
        ({ getPaymentModeList }) => getPaymentModeList)

    const getIntegrationTypeListRes = useSelector(
        ({ adminGetIntegrationType }) => adminGetIntegrationType
    );
    console.log("getIntegrationTypeListRes", getIntegrationTypeListRes)

    const createGatewayMappingRes = useSelector(
        ({ createGatewayMapping }) => createGatewayMapping
    )

    const adminCurrencyList = useSelector(
        ({ adminCurrencyList }) => adminCurrencyList
    );

    const handleChangePageForward = (pageaa, newPage) => {
        setPage(newPage);

        // getWalletTransactionListReq()
        console.log("Arrow", newPage)
    };

    // const handleChangeRowsPerPage = (event) => {

    // 	setRowsPerPage(parseInt(event.target.value));
    // 	setPageNo(0);

    // };
    const handleChangeRowsPerPage = (event) => {
        const newRowsPerPage = parseInt(event.target.value, 10);
        const currentFirstRowIndex = page * rowsPerPage;

        const newPage = Math.floor(currentFirstRowIndex / newRowsPerPage);

        setRowsPerPage(newRowsPerPage);
        setPage(newPage);
    };

    // useEffect
    useEffect(() => {
        if (regenerateTokenRes.data.status == "success") {
            const getCustomerIdAndNameReq = {
                loginDetails: {
                    walletOwnerId: regenerateTokenRes.data.partnerId || "",
                },
                actionCustomerMasterRequestVO: {
                    customerNameOrId: "",
                },
            };

            dispatch(getCustomerIdAndNameList(getCustomerIdAndNameReq, authToken));
        }
    }, [regenerateTokenRes.data.status]);

    useEffect(() => {
        if (PayModeID && CardTypeID) {
            console.log("first GateWay", regenerateTokenRes.data.partnerId)
            if (regenerateTokenRes.data.status == "success") {
                const getWayListReq = {
                    walletOwnerId: regenerateTokenRes.data.partnerId || "",
                    paymentBrand: PayModeID,
                    paymentMode: CardTypeID,
                    integrationType: dialogIntegrationType

                };
                dispatch(getWayList(getWayListReq, authToken));
            }
        }
    }, [regenerateTokenRes.data.status, PayModeID, CardTypeID]);

    useEffect(() => {
        if (dialogIntegrationType && regenerateTokenRes.data.status == "success") {
            const getWayListReq = {
                walletOwnerId: regenerateTokenRes.data.partnerId || "",
                paymentBrand: PayModeID || "",
                paymentMode: CardTypeID || "",
                integrationType: dialogIntegrationType // ✅ sends type to backend
            };
            dispatch(getWayList(getWayListReq, authToken));
        }
    }, [dialogIntegrationType]);

    useEffect(() => {
        if (regenerateTokenRes.data.status == "success") {
            getWalletOwnerIdAndNameListReq();
            getIntegrationTypeListReq();
            const getWayListReq = {
                walletOwnerId: regenerateTokenRes.data.partnerId || "",
                paymentBrand: "",
                paymentMode: "",
            };
            dispatch(getWayList(getWayListReq, authToken));
        }
    }, [regenerateTokenRes.data.status]);

    useEffect(() => {
        if (createGatewayMappingRes.success) {
            setAddOpen(false);
            NotificationPopups(
                "success",
                "Success",
                createGatewayMappingRes.data.description
            );
        }
        if (createGatewayMappingRes.failed) {
            setAddOpen(false);
            NotificationPopups(
                "error",
                "Failed",
                createGatewayMappingRes.data.description
            );
        }
    }, [createGatewayMappingRes])

    useEffect(() => {
        if (deleteMapping.success) {
            getAllGatewayMappingListReq();
            setopenConfirm(false);
            NotificationPopups(
                "success",
                "Success",
                deleteMapping.data.description
            );
        }
        if (deleteMapping.failed) {
            getAllGatewayMappingListReq();
            setopenConfirm(false);
            NotificationPopups(
                "error",
                "Failed",
                deleteMapping.data.description
            );
        }
    }, [deleteMapping])

    // API Requests
    const getAllGatewayMappingListReq = () => {
        setIsLoading(true);
        setGetIntegrationListStatus(true);
        console.log("memberId.split('-')[0],", memberId.split('-')[0], memberId)
        let req = {
            walletOwnerId: regenerateTokenRes.data.partnerId || "",
            merchantId: memberId.split('-')[0],
            gatewayId: integrationname.split('-')[0]
        };
        dispatch(allGatewayMappingList(req, authToken));
    };

    const getAllIntegrationMappingListFunc = () => {
        if (getIntegrationListStatus) {
            if (getAllGatewayMappingListRes.data.status == "success") {
                setIsLoading(false);
                setGetIntegrationListArray(
                    [].concat(getAllGatewayMappingListRes.data.gatewayRequestVOList)
                );
            }
            if (getAllGatewayMappingListRes.data.status == "failed") {
                setIsLoading(false);
                setGetIntegrationListArray(getAllGatewayMappingListRes.data);
                if (
                    getAllGatewayMappingListRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    getAllGatewayMappingListRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
            if (getAllGatewayMappingListRes.data.status == "NOT FOUND") {
                setIsLoading(false);
                setGetIntegrationListArray(getAllGatewayMappingListRes.data);  //([]) Set as an empty array
            }
        }
    };

    useEffect(() => {
        getAllIntegrationMappingListFunc();
    }, [getAllGatewayMappingListRes.data.status]);



    const getIntegrationTypeListReq = () => {
        // setGetIntegrationTypeStatus(true);
        const req = {
            ownerMasterRequestVO: {
                // adminId: 2
                adminId: val.adminIDS
            }
        };
        dispatch(
            adminGetIntegrationTypeList(req, regenerateTokenRes.data.AuthToken)
        );
    };

    const getWalletOwnerIdAndNameListReq = () => {
        setGetWalletOwnerIdStatus(true);
        dispatch(
            getWalletOwnerIdAndNameList(
                {
                    loginDetails: {
                        // adminId: "2"
                        adminId: val.adminIDS
                    }
                },
                regenerateTokenRes.data.AuthToken
            )
        );
    };

    const getPaymentBrandListReq = () => {
        const req = {
            walletOwnerId: regenerateTokenRes.data.partnerId || "",
        }
        dispatch(getPaymentBrandList(req, authToken));
    };

    useEffect(() => {
        if (regenerateTokenRes.data.status == "success") {
            getPaymentBrandListReq()
            getPaymentModeListReq()
        }
    }, [regenerateTokenRes.data.status])

    const getPaymentModeListReq = () => {
        const req = {
            walletOwnerId: regenerateTokenRes.data.partnerId || "",
            paymentBrand: ""
        }
        dispatch(getPaymentModeList(req, authToken));
    }

    const createGatewayMappingReq = () => {
        let req = {
            walletOwnerId: regenerateTokenRes.data.partnerId || "",
            merchantId: MemberID.split("-")[0],
            gatewayAccountIdList: [Gateway.split("-")[0]]
        }
        dispatch(createGatewayMapping(req, authToken));
        // console.log('Create Account Request: ', req)
    };

    // Handle Changes
    const handleChange = ({ target: { name, value } }) => {
        // if (name === "searchWalletOwnerId") {
        //     setSearchWalletOwnerId(value);
        // }
        // if (name === "memberId") {
        //     Util.verifyAlphabet(value)
        //         ? setMemberId(value)
        //         : setMemberId(memberId)
        // }
        if (name === "memberId") {
            setMemberId(value)
        }
        if (name === "integrationname") {
            setIntegrationName(value)
        }
        // if (name === "gateway") {
        //     Util.verifyAlphabet(value) ? setUser(value) : setUser(Gateway)
        // }
        if (name === "searchIntegrationType") {
            setSearchIntegrationType(value == "All" ? "" : value);
            setDialogIntegrationType(value == "All" ? "" : value); // ✅ add this
             setUser(prev => ({ ...prev, Gateway: "" })); // ✅ clear stale gateway
        }
    };

    // HandleClose

    const handleClose = () => {
        setUser({
            MemberID: "",
            PayModeID: "",
            CardTypeID: "",
            Gateway: "",
        });
        // setOpen(false);
        // setEditOpen(false);
        // setViewOpen(false);
        setAddOpen(false);
        setDialogIntegrationType(""); // ✅ add this

    };

    const handleDeleteClose = () => {
        setDeleteMapId("value");
        setopenConfirm(false);
    }

    const deleteMappingFunc = (value) => {
        setDeleteMapId(value);
        setopenConfirm(true);
    };

    const deleteMappingFuncHandler = () => {

        const req = {
            mappingId: deleteMapId,
            walletOwnerId: regenerateTokenRes.data.partnerId
        }

        dispatch(deleteGatewayMapping(req, authToken));
    }

    // Functions
    const addRole = (e) => {
        setUser({
            MemberID: "",
            PayModeID: "",
            CardTypeID: "",
            Gateway: "",
        });
        // setNotificationOpen(false);
        // setEditOpen(false);
        // setViewOpen(false);
        setAddOpen(true);
    };

    // const getWalletOwnerIdStatusFunc = () => {
    //     if (getWalletOwnerIdStatus) {
    //         if (getWalletOwnerIdRes.data.status == "success") {
    //             setGetWalletOwnerIdResArray(
    //                 [].concat(getWalletOwnerIdRes.data.ownerList)
    //             );
    //         }
    //         if (getWalletOwnerIdRes.data.status == "failed") {
    //             setGetWalletOwnerIdResArray(getWalletOwnerIdRes.data);
    //         }
    //     }
    // };

    // Table view,edit
    // const setData = (row, fs) => {
    //     setUser({
    //         MemberID: row.MemberID,
    //         PayModeID: row.PayModeID,
    //         CardTypeID: row.CardTypeID,
    //         Gateway: row.Gateway,
    //     });
    //     if (fs == "view") {
    //         setEditOpen(false);
    //         setNotificationOpen(false);
    //         setViewOpen(true);

    //     }
    //     if (fs == "edit") {
    //         setNotificationOpen(false);
    //         setViewOpen(false);
    //         setEditOpen(true);
    //     }
    // };


    useEffect(() => {
        return () => {
            dispatch(resetGetCustomerIdAndNameList());
            dispatch(resetGetPaymentModeList());
            dispatch(resetGetPaymentBrandList());
            dispatch(resetGetWayList());
            dispatch(resetAllGatewayMappingList());
            dispatch(resetAdminGetIntegrationTypeList());
            dispatch(resetGetWalletOwnerIdAndNameList());
            dispatch(resetCreateGatewayMapping());
            dispatch(resetDeleteGatewayMapping());
        }
    }, [])

    const filterOptionsss = (options, { inputValue }) => {
        if (inputValue.length < 3) {
            return [];
        }

        const filterOptionsList = options.filter(
            (option) =>
                option.includes(inputValue) ||
                ""
        );

        return filterOptionsList.slice(0, 20);
    }

    const filterOptionsMM = (options, { inputValue }) => {
        if (inputValue.length < 3) {
            return [];
        }

        const filterOptionsList = options.filter(
            (option) =>
                option.includes(inputValue) ||
                ""
        );

        return filterOptionsList.slice(0, 20);
    }

    // ✅ This exists in AdminGatewayManagement but is MISSING in MemberMapping
    useEffect(() => {
        if (getIntegrationTypeListRes.data.status === "success") {
            setGetIntegrationTypeArray(
                [].concat(getIntegrationTypeListRes.data.integrationTypeList)
            );
        }
        if (getIntegrationTypeListRes.data.status === "failed") {
            if (getIntegrationTypeListRes.data.description === "session out") {
                SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
            }
            if (getIntegrationTypeListRes.data.description === "Authorization failed") {
                regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
            }
        }
    }, [getIntegrationTypeListRes.data.status]);


    return (
        <>
            <Layout>
                <Card>
                    {/* Search Filter */}
                    <Grid
                        container
                        style={{
                            padding: "10px",
                            marginTop: "1rem",
                            marginLeft: "1rem"
                        }}
                    >
                        <Grid item md={4} sm={12} lg={9}></Grid>
                        <Grid item md={4} sm={12} lg={3}>
                            <CustomButton
                                variant="contained"
                                style={{ backgroundColor: "#00b9f5", color: "white" }}
                                size="small"
                                onClick={() => addRole()}
                            >
                                Create Mapping
                            </CustomButton>
                        </Grid>
                    </Grid>

                    <Grid container spacing={2} style={{ padding: "25px", gap: "10px" }}>

                        <Grid item xs={12} sm={12} md={4} lg={4}>
                            <Autocomplete
                                id="combo-box-demo"
                                options={[].concat(
                                    getCustomerIdAndNameListRes.data.currencyList || [""]
                                )}
                                getOptionLabel={(option) => option}
                                filterOptions={filterOptionsss}
                                renderInput={(params) => (
                                    <TextField
                                        autoFocus
                                        margin="dense"
                                        id="memberId"
                                        label="Member ID"
                                        type="text"
                                        fullWidth
                                        {...params}
                                        value={memberId}
                                        name="memberId"
                                        onBlur={handleChange}
                                        variant="standard"
                                        sx={{
                                            "& .MuiInput-underline:before": {
                                                borderBottomColor: "gray", // White color for the underline before focus
                                            },
                                            "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                                                borderBottomColor: "gray", // White color on hover
                                            },
                                            "& .MuiInput-underline:after": {
                                                borderBottomColor: "gray", // White color after focus
                                            },
                                        }}
                                    />
                                )}
                            />
                        </Grid>

                        {/* <Grid item xs={12} sm={12} md={3} lg={3}>
								<Autocomplete
									id="combo-box-demo"
									options={[].concat(
										getCustomerIdAndNameListRes.data.currencyList || [""]
									)}
									getOptionLabel={(option) => option}
									filterOptions={filterOptionsL}
									value={customerId}
									onChange={handleChange}
									onInputChange={(event, newInputValue) => {
										setCustomerId(newInputValue);
									}}
									renderInput={(params) => (
										<TextField
											autoFocus
											margin="dense"
											id="name"
											label="Customer ID"
											style={{ marginTop: "3px" }}
											// required
											type="tel"
											fullWidth
											{...params}

											name="customerId"

											variant="standard"
											sx={{
												"& .MuiInput-underline:before": {
												  borderBottomColor: "gray", // White color for the underline before focus
												},
												"& .MuiInput-underline:hover:not(.Mui-disabled):before": {
												  borderBottomColor: "gray", // White color on hover
												},
												"& .MuiInput-underline:after": {
												  borderBottomColor: "gray", // White color after focus
												},
											  }}
										/>
									)}
								/>
							</Grid> */}

                        <Grid item xs={12} sm={12} md={4} lg={4}>
                            <Autocomplete
                                id="combo-box-demo"
                                options={[].concat(
                                    getWayListRes.data.gatewayRequestVOList || [""]
                                )}
                                getOptionLabel={(user) => `${user.gatewayId}-${user.memberUserName}-${user.memberId}-${user.currency}-${user.paymentBrand}-${user.paymentMode}`}
                                filterOptions={filterOptions}
                                renderInput={(params) => (
                                    <TextField
                                        autoFocus
                                        margin="dense"
                                        id="integrationname"
                                        label="Integration Name"
                                        type="text"
                                        fullWidth
                                        {...params}
                                        value={integrationname}
                                        name="integrationname"
                                        onBlur={handleChange}
                                        variant="standard"
                                        sx={{
                                            "& .MuiInput-underline:before": {
                                                borderBottomColor: "gray", // White color for the underline before focus
                                            },
                                            "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                                                borderBottomColor: "gray", // White color on hover
                                            },
                                            "& .MuiInput-underline:after": {
                                                borderBottomColor: "gray", // White color after focus
                                            },
                                        }}

                                    />
                                )}
                            />
                        </Grid>

                        <Grid item xs={12} sm={12} md={2} lg={2}>
                            <CustomButton
                                style={{
                                    padding: "8px"
                                }}

                                onClick={getAllGatewayMappingListReq}

                            >
                                Search<SearchIcon />
                            </CustomButton>
                        </Grid>
                    </Grid>
                </Card>

                {isLoading ? (
                    <LoadingSpinner />
                ) : Array.isArray(getIntegrationListArray) && getIntegrationListArray.length > 0 && getIntegrationListStatus
                    ? (
                        <Card>
                            <Grid
                                container
                                style={{
                                    padding: "10px"
                                }}
                            >
                                <Grid xs={12} sm={12} md={12} lg={12}>
                                    <Typography variant="body1" style={{ fontWeight: "700" }}>
                                        Member Mapping
                                    </Typography>
                                </Grid>
                                <TableContainer component={Paper} className="my-3">
                                    <Table
                                        className={classes.table}
                                        size="small"
                                        aria-label="a dense table"
                                    >
                                        <TableHead>
                                            <TableRow className="tableHeaderColor">
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Wallet Owner Id
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Merchant Id
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Integration Name
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Gateway Id
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Mapping Id
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Action
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>

                                        <TableBody>
                                            {getIntegrationListArray &&
                                                []
                                                    .concat(getIntegrationListArray)
                                                    .slice(
                                                        page * rowsPerPage,
                                                        page * rowsPerPage + rowsPerPage
                                                    )
                                                    .map((row, index) => (
                                                        <TableRow>
                                                            <TableCell align="center">
                                                                {row.walletOwnerId}
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {row.merchantId}
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {row.integrationName}
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {row.gatewayId}-{row.paymentMode}-{row.paymentBrand}
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {row.mappingId}
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                <Tooltip title="Delete">
                                                                    <CustomButton
                                                                        style={{
                                                                            padding: "8px"
                                                                        }}
                                                                        onClick={() =>
                                                                            deleteMappingFunc(row.mappingId)
                                                                        }
                                                                    >
                                                                        {
                                                                            <DeleteIcon
                                                                                style={{
                                                                                    color: "#fff",
                                                                                    fontSize: "20px"
                                                                                }}
                                                                            />
                                                                        }
                                                                    </CustomButton>
                                                                </Tooltip>
                                                            </TableCell>
                                                        </TableRow>
                                                    ))}
                                        </TableBody>
                                    </Table>
                                    <TablePagination
                                        rowsPerPageOptions={[5, 10, 25]}
                                        component="div"
                                        count={getIntegrationListArray.length}
                                        rowsPerPage={rowsPerPage}
                                        page={page}

                                        onPageChange={handleChangePageForward}
                                        onRowsPerPageChange={handleChangeRowsPerPage}
                                    // handleChangeRowsPerPage={handleChangeRowsPerPage}
                                    // page={page}
                                    // onChangePage={handleChangePage}
                                    // onChangeRowsPerPage={handleChangeRowsPerPage}
                                    />


                                </TableContainer>
                            </Grid>
                        </Card>
                    ) : (
                        <Card>
                            <Grid
                                container
                                style={{
                                    padding: "10px"
                                }}
                            >
                                <Grid xs={12} sm={12} md={12} lg={12}>
                                    <Typography variant="body1" style={{ fontWeight: "700" }}>
                                        Member Mapping
                                    </Typography>
                                </Grid>
                                <Grid xs={12} sm={12} md={12} lg={12}>
                                    <Alert
                                        className="my-3 tableHeaderColor"
                                        variant="secondary"
                                    // style={{ backgroundColor: "#00b9f5", color: "white" }}
                                    >
                                        No Records Found!
                                    </Alert>
                                </Grid>
                            </Grid>
                        </Card>
                    )}


                <div>
                    <Dialog open={openConfirm} onClose={handleDeleteClose}>
                        <DialogTitle style={{ width: "400px" }}>Are you sure?</DialogTitle>
                        <DialogActions className="p-3">
                            <CustomButton
                                style={{
                                    backgroundColor: "#fff",
                                    color: "#000"
                                }}
                                variant="contained"
                                onClick={handleDeleteClose}
                            >
                                Cancel
                            </CustomButton>
                            <CustomButton
                                style={{
                                    backgroundColor: "#00b9f5",
                                    color: "white"
                                }}
                                variant="contained"
                                onClick={deleteMappingFuncHandler}
                            >
                                Yes
                            </CustomButton>
                        </DialogActions>
                    </Dialog>
                </div>

            </Layout>

            <div>
                <Dialog open={addOpen} onClose={handleClose} fullWidth>
                    <DialogTitle>Create Account</DialogTitle>
                    <DialogContent>

                        {/* <TextField
                            required
                            style={{ marginTop: "10px" }}
                            size="small"
                            color="primary"
                            type="text"
                            label="Member ID"
                            fullWidth={true}
                            name="MemberID"
                            value={MemberID || ""}
                            onChange={(e) => onInputChange(e, "alphabet")}
                        ></TextField> */}

                        <Grid item xs={12} sm={12} md={3} lg={3}>
                            <TextField
                                select
                                size="small"
                                color="primary"
                                type="text"
                                label="Integration Type"
                                fullWidth={true}
                                name="searchIntegrationType"
                                defaultValue={"All" || searchIntegrationType}
                                onChange={handleChange}
                                placeholder="Please Select Currency"
                                variant="standard"
                                InputProps={{
                                    sx: {
                                        "&:before": { borderBottomColor: "gray" }, // before focus
                                        "&:after": { borderBottomColor: "gray" },  // after focus
                                    },
                                }}
                                InputLabelProps={{
                                    sx: { color: 'gray' }, // Optional: if you want the label to be white
                                }}

                            >
                                <MenuItem value="All" selected="All">
                                    Select Integration Type
                                </MenuItem>
                                {getIntegrationTypeListRes.data.integrationTypeList &&
                                    getIntegrationTypeArray.map((x) => (
                                        <MenuItem value={x}>{x}</MenuItem>
                                    ))}
                            </TextField>
                        </Grid>

                        <Autocomplete
                            id="combo-box-demo"
                            options={[].concat(
                                getCustomerIdAndNameListRes.data.currencyList || [""]
                            )}
                            // onChange={(e) => onInputChange(e)}
                            getOptionLabel={(option) => option}
                            filterOptions={filterOptionsMM}
                            componentsProps={{
                                popper: {
                                    style: { zIndex: 9999 }
                                }
                            }}
                            // onChange={(e) => onInputChange(e)}
                            renderInput={(params) => (
                                <TextField
                                    autoFocus
                                    margin="dense"
                                    id="memberId"
                                    label="Member Id"
                                    required
                                    name="MemberID"
                                    value={MemberID}
                                    type="text"
                                    fullWidth
                                    {...params}
                                    onBlur={(e) => onInputChange(e)}
                                    variant="standard"
                                    sx={{
                                        "& .MuiInput-underline:before": {
                                            borderBottomColor: "gray", // White color for the underline before focus
                                        },
                                        "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                                            borderBottomColor: "gray", // White color on hover
                                        },
                                        "& .MuiInput-underline:after": {
                                            borderBottomColor: "gray", // White color after focus
                                        },
                                    }}
                                />
                            )}
                        />

                        {dialogIntegrationType !== "CURRENCY_CONVERSION" && (
                            <TextField
                                select
                                size="small"
                                color="primary"
                                type="text"
                                label="Currency"
                                fullWidth={true}
                                name="searchCurrency"
                                // defaultValue={"All" || searchCurrency}
                                onChange={handleChange}
                                variant="standard"
                                sx={{
                                    "& .MuiInput-underline:before": {
                                        borderBottomColor: "gray", // White color for the underline before focus
                                    },
                                    "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                                        borderBottomColor: "gray", // White color on hover
                                    },
                                    "& .MuiInput-underline:after": {
                                        borderBottomColor: "gray", // White color after focus
                                    },
                                }}

                            >
                                <MenuItem value="All" selected="All	">
                                    Select Currency
                                </MenuItem>
                                {adminCurrencyList.success &&
                                    []
                                        .concat(adminCurrencyList.data.currencyList)
                                        .map((x) => <MenuItem value={x}>{x}</MenuItem>)}
                            </TextField>)}

                        {dialogIntegrationType !== "CURRENCY_CONVERSION" && (
                            <TextField
                                required
                                style={{ marginTop: "10px" }}
                                select
                                size="small"
                                color="primary"
                                type="text"
                                label="PayMode"
                                fullWidth={true}
                                name="PayModeID"
                                defaultValue={"All" || PayModeID}
                                onChange={(e) => onInputChange(e)}
                                variant="standard"
                                sx={{
                                    "& .MuiInput-underline:before": {
                                        borderBottomColor: "gray", // White color for the underline before focus
                                    },
                                    "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                                        borderBottomColor: "gray", // White color on hover
                                    },
                                    "& .MuiInput-underline:after": {
                                        borderBottomColor: "gray", // White color after focus
                                    },
                                }}

                            >
                                <MenuItem value="All" selected="All">
                                    Select PayMode
                                </MenuItem>
                                {getPaymentBrandListRes.data.paymentBrandList &&
                                    [].concat(getPaymentBrandListRes.data.paymentBrandList)
                                        .map((x) => (
                                            <MenuItem value={x}>
                                                {x}
                                            </MenuItem>
                                        ))}
                            </TextField>)}

                        {dialogIntegrationType !== "CURRENCY_CONVERSION" && (
                            <TextField
                                required
                                style={{ marginTop: "10px" }}
                                select
                                size="small"
                                color="primary"
                                type="text"
                                label="Card Type"
                                fullWidth={true}
                                name="CardTypeID"
                                defaultValue={"All" || CardTypeID}
                                onChange={(e) => onInputChange(e)}
                                variant="standard"
                                sx={{
                                    "& .MuiInput-underline:before": {
                                        borderBottomColor: "gray", // White color for the underline before focus
                                    },
                                    "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                                        borderBottomColor: "gray", // White color on hover
                                    },
                                    "& .MuiInput-underline:after": {
                                        borderBottomColor: "gray", // White color after focus
                                    },
                                }}

                            >
                                <MenuItem value="All" selected="All">
                                    Select Card Type
                                </MenuItem>
                                {getPaymentModeListRes.data.paymentBrandList &&
                                    [].concat(getPaymentModeListRes.data.paymentBrandList)
                                        .map((x) => (
                                            <MenuItem value={x}>
                                                {x}
                                            </MenuItem>
                                        ))}
                            </TextField>)}

                        {/* <TextField
                            required
                            style={{ marginTop: "10px" }}
                            size="small"
                            color="primary"
                            type="text"
                            label="Gateway"
                            fullWidth={true}
                            name="Gateway"
                            value={Gateway || ""}
                            onChange={(e) => onInputChange(e, "alphabet")}
                        ></TextField> */}
                        <Autocomplete
                            id="combo-box-demo"
                            options={[].concat(
                                getWayListRes.data.gatewayRequestVOList || [""]
                            )}
                            getOptionLabel={(user) => `${user.gatewayId}-${user.memberUserName}-${user.memberId}-${user.currency}-${user.paymentBrand}-${user.paymentMode}-${user.isTest}`}
                            filterOptions={filterOptions}
                            componentsProps={{
                                popper: {
                                    style: { zIndex: 9999 }
                                }
                            }}
                            // onChange={(e) => onInputChange(e)}
                            renderInput={(params) => (
                                <TextField
                                    autoFocus
                                    margin="dense"
                                    id="gateway"
                                    label="Gateway"
                                    required
                                    type="text"
                                    fullWidth
                                    {...params}
                                    value={Gateway}
                                    variant="standard"

                                    name="Gateway"
                                    onBlur={(e) => onInputChange(e)}
                                    sx={{
                                        "& .MuiInput-underline:before": {
                                            borderBottomColor: "gray", // White color for the underline before focus
                                        },
                                        "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                                            borderBottomColor: "gray", // White color on hover
                                        },
                                        "& .MuiInput-underline:after": {
                                            borderBottomColor: "gray", // White color after focus
                                        },
                                    }}
                                // onBlur={handleChange}
                                />
                            )}
                        />


                    </DialogContent>

                    <DialogActions style={{ padding: "14px" }}>
                        <CustomButton
                            style={{
                                backgroundColor: "#fff",
                                color: "#000"
                            }}
                            variant="contained"
                            onClick={handleClose}
                        >
                            Cancel
                        </CustomButton>
                        <CustomButton
                            style={{
                                backgroundColor: "#00b9f5",
                                color: "white"
                            }}
                            variant="contained"
                            onClick={createGatewayMappingReq}
                        >
                            Add
                        </CustomButton>
                    </DialogActions>
                </Dialog>
            </div >
        </>
    )
}

export default MemberMapping;